<template>
  <div class="campaign-edit-section">
    <campaign-warning-modal
        :backupAdOverCreditLimit="backupAdOverCreditLimit"
        :maxAdCampaignCredits="maxAdCampaignCredits"
        :parentAdOverCreditLimit="parentAdOverCreditLimit"
        :showBackup="showBackup"
        :showFiltersWarning="showFiltersWarning"
        :showWarning="showWarning"
        :smsSend="smsSend"
        @cancelBackup="shouldCancelBackup = true"
        @closeWarning="closeWarningModal"
        @confirmedModal="checkForSecondModal"
        @sendCampaign="sendCampaign"
        @setShowBackupStatus="setShowBackupStatus">
    </campaign-warning-modal>

    <modal
        v-if="showAlertModal"
        wrapperClasses="modal"
        @close="showAlertModal = false">
        <h3 slot="header" class="title">sponsored image update</h3>
        <div slot="body" class="body">
          <p>a change has been made to the sponsored image during your campaign creation, review the sponsored image and reattach the image to your campaign to send free credits.</p>
        </div>
        <div
            slot="action"
            class="button larger modal-click-action"
            @click="removeAd">
          continue
        </div>
    </modal>

    <modal
        v-if="showAgreementModal"
        wrapperClasses="agreement-modal">
        <h2 slot="header" class="title">
          <img v-bind:src="stashboardLogoImage" alt="stashboard-logo">
          <br/>Attention springbig fam! We have a lot of game-changing news to share with you about our recent platform update.</h2>
        <div slot="body" class="body">
          <h3>With this new expansion to the springbig platform, you get back the power to share whatever kind of content you want with your most loyal, highest-spending customers, while we secure your communications to provide additional protection for your exclusive content</h3>
          <ol>
            <li>  First, you’ll see the stashboard campaign creation page. Here you have the ability to write whatever engaging messages and upload exciting creative images to be displayed on what we call a stashboard, which is branded to your cannabis retail store.</li>
            <li>  Why is the deliverability score gone? Because with stashboards all of your campaigns are automatically 100% optimized!</li>
            <li>  Next, you can choose from our library of pre-optimized text messages that will be sent to notify your customer of your new content. </li>
            <li>  You will still have access to the other awesome autoconnects and dynamic filtering options you love, allowing you to target your audience and personalize the experience.</li>
            <li>  Don’t forget you can add links for track offers, the target wallet, or any links to your website, e-commerce, etc. onto your stashboard!</li>
            <li>  When your customer receives the pre-optimized text, they will be directed to your stashboard through the secure link, keeping your communications exclusive to your members.</li>
          </ol>
          <p>To make this easier, we went ahead and created some educational content for you and your team. Please take advantage of the link below to learn more about stashboards!</p>
          <a href="https://springbig.zendesk.com/hc/en-us/articles/1500010744021-Webinar-The-Next-Level-of-Texting-with-stashboards" target="_blank" rel="noopener noreferrer"><u>click here for more information</u></a>
          <p>We want to hear from you! If you have any questions, please contact your clients success manager today</p>
        </div>
        <div
            slot="action"
            class="button larger modal-click-action justify-center"
            @click="setAgreementTerms"
            data-cy="agreement-modal-button"
            >
          get started
        </div>
        <div slot="footer" class="modal-footer">
          <label>
            <input type="checkbox" v-model="agreementCheck" data-cy="agreement-checkbox">
            do not show this message again
          </label>
          <br/>
        </div>
    </modal>

    <h1 class="page-header text-center">new campaign</h1>

    <transition name="slide-down" v-if="useCampaignEditor2">
      <div v-if="campaignHasErrors">please complete required fields in red</div>
    </transition>

    <div :class="['campaign-alerts', Object.keys(alerts).length && !campaignLoading ? 'slide-down' : 'slide-up']" v-if="!useCampaignEditor2">
      <transition-group name="slide-down">
        <alert
            v-for="(alert, key, index) in alerts"
            :key="key + index"
            :alert="alert"
            :alertKey="key"
            @updateAlerts="updateAlerts">
        </alert>
      </transition-group>
    </div>

    <loading-icon
        v-if="campaignLoading"
        loadingIconClasses="campaign-loading">
    </loading-icon>
    <div v-else class="row">
      <campaign-creation-content
          :campaign="campaign"
          :backupCampaignIds="backupCampaigns"
          :campaignId="campaignId"
          :campaignSendTime="sendAtLocal"
          :emailSend="emailSend"
          :selectedView="selectedView"
          :shouldCancelBackup="shouldCancelBackup"
          :showBackup="showBackup"
          :smsSend="smsSend"
          @setShowBackupStatus="setShowBackupStatus"
          @toggleSend="toggleSend"
          @updateAlerts="updateAlerts"
          @updateCampaign="updateCampaign"
          @setApiError="setApiError">

        <recipient-dropdown
          slot="groups"
          :pre-selected-filters="adFilters"
          :groups-with-selected="groupsWithSelected"
          @update:selected="updateSelectedRecipients"
          style="margin-bottom:35px"
          data-cy="recipient-filter-button"
          ref="recipientDropdown"
        >
          <div>recipient filters</div>
          <div>(<counter :start="prevRecipientCount" :end="totalRecipientCount" />)</div>
        </recipient-dropdown>

        <campaign-view-toggle
            slot="selectedViewToggle"
            :emailInView="selectedView === 'email'"
            :smsInView="selectedView === 'sms'"
            @toggleSelectedView="toggleSelectedView">
        </campaign-view-toggle>
        <scheduler
            v-if="showBrands"
            ref="scheduler"
            slot="scheduler"
            :sendAtLocal="sendAtLocal"
            :sendNow="sendNow"
            :min="schedulerMin"
            :max="schedulerMax"
            :attachedAdHasTimeRange="attachedAdHasTimeRange"
            @configUserInteractions="configUserInteractions"
            @isAllValid="isAllValid"
            @updateCampaign="updateCampaign">
        </scheduler>
      </campaign-creation-content>

      <div id="campaign-settings-wrapper" class="medium-4 columns">
        <ads-list
            v-if="showBrands"
            :adAsLink="adAsLink"
            :attachedAdId="adId"
            :campaignId="campaignId"
            :campaignSendTime="sendAtLocal"
            :isEmailType="!smsSend || selectedView === 'email'"
            :recipientCount="totalRecipientCount"
            :sendAtLocal="sendAtLocal"
            :sendNow="sendNow"
            :shouldShowAgreementModal="showAgreementModal"
            :smsSend="smsSend"
            :smsSent="smsSent"
            @deselectedAd="deselectedAd"
            @selectedAd="selectedAd"
            @setAvailableDates="setAvailableDates"
            @updateAlerts="updateAlerts"
            @updateCampaign="updateCampaign"
          ref="adslist" />
        <scheduler
            v-else
            :sendAtLocal="sendAtLocal"
            :sendNow="sendNow"
            @isAllValid="isAllValid"
            @configUserInteractions="configUserInteractions"
            @updateCampaign="updateCampaign">
        </scheduler>
      </div>

      <div class="send-cancel-section">
        <div class="large-12 columns center-button">
          <input type="submit"
                 name="commit"
                 value="send campaign"
                 :class="['button larger', { disabled: !validCampaign }]"
                 id="send-campaign-button"
                 @click.prevent="getAds"
                 data-cy="send-campaign-button">
        </div>
        <div class="large-12 columns">
          <div class="float-right link-delete" name="cancel_campaign" @click="cancelCampaign" data-cy="cancel-campaign-button">cancel</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import AdsList from '../../components/AdsList/AdsList'
  import Alert from '../../components/shared/Alert'
  import AxiosMixin from '../../mixins/AxiosMixin'
  import CampaignCreationContent from '../../components/Campaigns/CampaignCreationContent'
  import CampaignViewToggle from '../../components/Campaigns/CampaignViewToggle'
  import CampaignWarningModal from '../../components/Campaigns/CampaignWarningModal'
  import GroupWidget from '../../components/GroupWidget/index'
  import LoadingIcon from '../../components/shared/LoadingIcon'
  import MessageModule from '../../store/modules/message'
  import Modal from '../../components/shared/Modal'
  import Scheduler from '../../components/Campaigns/CampaignScheduler'
  import stashboardLogoImage from 'campaigns/stashboards_logo_color.png'
  import { isInDateTimeRangeUtil, removeTimeZoneAndGetDateUtil } from "../../utilities"
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { merchantsAPI } from "../../services/api"
  import { textMarketingAPI } from "../../services/api/textMarketing";
  import format from 'date-fns/format'
  import CampaignCreator from "../../components/Campaigns2/campaign-creator";
  import RecipientDropdown from "../../components/Campaigns2/recipient-dropdown";
  import {campaignAPI} from "../../services/api/campaignAPI";
  import {Counter} from "@springbig/sb-components";

  export default {
    name: 'CampaignEdit',

    components: {
      RecipientDropdown,
      CampaignCreator,
      AdsList,
      Alert,
      CampaignCreationContent,
      CampaignViewToggle,
      CampaignWarningModal,
      GroupWidget,
      LoadingIcon,
      Modal,
      Scheduler,
      Counter
    },

    mixins: [AxiosMixin],
    props: {
      groupsWithSelected: Object
    },

    data() {
      return {
        campaign: null,
        allValid: false,
        agreementCheck: false,
        attachedAdImageUUID: null,
        availableDates: {},
        backupCampaigns: null,
        campaignAdId: null,
        campaignId: null,
        campaignLoading: true,
        emailSend: false,
        maxAdCampaignCredits: 2,
        noFiltersSelected: null,
        openGroupItem: null,
        selectedView: 'sms',
        sendAtLocal: null,
        sendNow: null,
        showBackup: false,
        showFiltersWarning: false,
        shouldCancelBackup: false,
        showWarning: false,
        smsContent: null,
        smsSend: true,
        smsSent: null,
        showAlertModal: false,
        showAgreementModal: false,
        submit: null,
        stashboardLogoImage,
        schedulerMin: null,
        schedulerMax: null,
        attachedAdHasTimeRange: false,
        adFilters: null,
        loadingTotalCount: false,
        prevRecipientCount: 0,
        totalRecipientCount: 0
      }
    },

    methods: {
      async updateSelectedRecipients(frag) {
        await campaignAPI.updateGroups(this.campaign.id, frag);
        await this.refreshTotalCount();
      },
      selectedAd(ad) {
        this.attachedAdHasTimeRange = !!ad?.time_range_start && !!ad?.time_range_end

        if (!ad) {
          this.schedulerMin = null
          this.schedulerMax = null
          this.adFilters = null
          return
        }

        const hasAdFilters = ad.merchant_tag_ids?.length || ad.merchant_segment_ids?.length

        if (hasAdFilters) {
          this.adFilters = {
            segments: ad.merchant_segment_ids,
            tags: ad.selected_groups.find(({id}) => id === 'category')?.display_names?.join(',') || '',
            groups_with_selected: ad.selected_groups
          }
        } else { this.adFilters = null }

        const startDate = ad.send_at_start.split('T')[0];
        const startTime = this.attachedAdHasTimeRange ? ad.time_range_start.split('T')[1] : "00:00:00Z"
        const endDate = ad.send_at_end.split('T')[0];
        const endTime = this.attachedAdHasTimeRange ? ad.time_range_end.split('T')[1] : "23:59:59Z"

        const start = `${startDate}T${startTime}`;
        const end = `${endDate}T${endTime}`;

        this.schedulerMin = new Date(start.substring(0, start.length - 1));
        this.schedulerMax = new Date(end.substring(0, end.length - 1));
      },

      deselectedAd(ad) {
        if (!!ad && (ad?.merchant_segment_ids?.length || ad?.merchant_tag_ids?.length)) {
          this.adFilters = null
        }
        if (!!ad?.time_range_start && !!ad?.time_range_end) {
          this.schedulerMin = null
          this.schedulerMax = null
        }
      },

      afterLoadCampaign(data, extraError) {
        const campaign = data?.campaign
        if (campaign?.status) { return window.location.href= `/campaigns` }

        if(campaign) {
          this.setCampaignData(true, campaign, extraError)
        } else {
          this.setApiError(null, extraError)
        }

        this.refreshTotalCount();
        this.$store.commit('SET_NOTIFICATION_TEMPLATES', data.templates)
        this.campaignLoading = false
      },

      afterSendCampaign(data, extraError) {
        const errorKeys = Object.keys(data.errors),
          noErrors = errorKeys.length < 1

        if (noErrors) {
          this.updateAlerts(extraError.errorType, {})
          window.location.href= `/campaigns/${this.campaignId}`
        } else {
          let errorText = ''
          errorKeys.forEach(key => errorText += `${data.errors[key]} `)
          this.setApiError(errorText, extraError)
        }
      },

      afterUpdateCampaign(data, extras) {
        const campaign = data?.campaign

        if (!this.classicCampaignsEnabled && data?.characters) {
          /**
           * This update happens here because we need to include notification templates in the character count
           * For expediency we bypass this update for classic campaigns since we don't have an endpoint available yet for the character count
           */
          this.$store.dispatch(`message/UPDATE_SMS_CONTENT`, { smsContent: '', characterCount: data?.characters })
        }

        if(data?.credits != null) {
          this.$store.commit(`message/SET_CREDITS`, data.credits);
        }

        this.$store.commit('SET_NOTIFICATION_TEMPLATES', data.templates)

        if (campaign && !!extras?.isCancel) { return window.location.href= `/campaigns` }
        if (campaign && !!extras?.shouldSend) { return this.sendCampaign() }
        campaign && this.setCampaignData(false, campaign, extras)
        !campaign && this.setApiError(null, extras)
      },

      cancelCampaign() {
        window.onbeforeunload = null
        let confirm = window.confirm("are you sure you want to cancel this campaign?")
        if (confirm) {
          this.shouldCancelBackup = true
          const dataToUpdate = { ad_id: null, sms_sent: null, cancelled_at: format(new Date(), "yyyy-MM-dd HH:mm") }
          this.updateCampaign(dataToUpdate, false, true)
        }
      },

      checkForSecondModal() {
        if (this.showFiltersAlert && this.noFiltersSelected) {
          this.showFiltersWarning = true
        } else {
          this.sendCampaign()
        }
      },

      closeWarningModal() {
        this.showWarning = false
        this.showFiltersWarning = false
      },

      configUserInteractions(itemKey, itemObject) {
        this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey, itemObject})
      },

      async initCampaign() {
        if(performance.navigation.type == 2){
          window.location.href= '/campaigns'
        } else {
          this.campaignId = this.$route.params.id
          if (this.campaignId) {
            this.loadCampaign()
            this.UPDATE_MESSAGE_ID_TYPE({messageId: this.campaignId, messageType: 'Campaign'})
            this.LOAD_CAMPAIGN_CONFIGURATION()
          }
        }
      },

      isAllValid(componentKey, componentErrors) {
        this.UPDATE_STATE_OBJECT({ itemKey: componentKey, itemObject: componentErrors})
      },

      loadCampaign() {
        const url = `/api/v3/campaigns/${this.campaignId}`,
          onExtraParam = { errorType: 'campaignLoad', errorText: 'we encountered an issue loading the campaign' }
        this.axiosMethod({url, onSuccess: this.afterLoadCampaign, onError: this.setApiError, onExtraParam})
      },

      sendCampaign() {
        window.onbeforeunload = null
        const isValid = this.validCampaign
        if (isValid) {
          const url = `/api/v3/campaigns/${this.campaignId}/update_on_send`,
            methodType = 'patch',
            params = { campaign: { status: true } },
            onExtraParam = { errorType: 'campaignSend', errorText: 'we encountered an issue saving the campaign' }
          this.axiosMethod({methodType, url, params, onSuccess: this.afterSendCampaign, onError: this.setApiError, onExtraParam})
        }
      },

      setApiError(error, extraError) {
        const errorText = extraError?.errorText || 'there was an error with this campaign, please refresh or contact support',
          message = error ? `${errorText}. ${error}` : errorText
        const loadErrorAlert = { extraClasses: "error-alert", message }
        this.updateAlerts(extraError.errorType, loadErrorAlert)
      },

      setAvailableDates(dates) {
        this.availableDates = dates
      },

      setCampaignData(isAfterLoad, campaignData, extraError) {
        this.campaign = campaignData;

        this.$store.commit('SET_CAMPAIGN', this.campaign);
        this.$store.commit('SET_SELECTED_NOTIFICATION_TEMPLATE', {
          id: 'message',
          templateId: campaignData.template_id
        });
        this.UPDATE_AD(campaignData?.ad)
        this.backupCampaigns = campaignData.backup_campaign_ids
        this.smsSend = campaignData.sms_send
        this.emailSend = campaignData.email_send
        this.UPDATE_MESSAGE_STATE({ stateKey: 'imageType', stateItem: campaignData?.image_type })
        this.sendAtLocal = campaignData.send_at_local ? format(removeTimeZoneAndGetDateUtil(campaignData.send_at_local), 'yyyy-MM-dd HH:mm') : null
        this.sendNow = campaignData.send_now
        this.smsContent = campaignData.sms_content
        this.smsSent = campaignData.sms_sent
        this.UPDATE_SMS_CONTENT({ smsContent: this.smsContent })
        this.UPDATE_COMMUNICATION_ITEMS({
          extensionType: campaignData.extension_type,
          mockUrl: campaignData.mock_url,
          rewardId: campaignData.reward_id,
          walletTarget: campaignData.wallet_target
        })

        if (campaignData.ad !== undefined) {
          this.attachedAdImageUUID = campaignData?.ad.ad_attachment.uuid
          this.campaignAdId = campaignData?.ad.ad_id
        }
        this.updateAlerts(extraError.errorType, {})
        isAfterLoad && this.setInitialContentView()
      },

      setInitialContentView() {
        const selectedView = this.smsSend ? 'sms' : 'email'
        this.toggleSelectedView(selectedView);
        this.refreshTotalCount();
      },

      setShowBackupStatus(showBackup) {
        this.showBackup = showBackup
        if (showBackup) { this.shouldCancelBackup = false }
      },

      shouldShowWarning() {
        if (this.validCampaign) {
          /* Related to DEV-8481 */
          /* We return false for shouldShowWarning to not show the modal anymore */
          /* During the refactoring, we will rip out the modal completely */
          /* Keeping the files and code in place for now (CampaignWarningModal.vue) */
          /* (checkForSecondModal was no joke) */
          const withAdOver2Credits = this.showBrands && (this.parentAdOverCreditLimit || this.backupAdOverCreditLimit),
            hasMedia = !!this.mediaCredits && !this.mmsAsLink,
            hasBackupEmojiOrMedia = hasMedia && this.backupHasEmoji|| !hasMedia && !!this.backupMediaCredits,
            hasEmojiOrMedia = this.hasEmoji || hasMedia || hasBackupEmojiOrMedia,
            shouldShowWarning = false
          this.updateCampaign({ sms_send: this.smsSend, email_send: this.emailSend })
          shouldShowWarning ? this.showWarning = true : this.checkForSecondModal()
        }
      },

      getAds(submit) {
        this.loading = true
        this.submit = submit
        merchantsAPI.getAds(this.campaignId).then((data) => {
          this.onGetAdsSuccess(data.ads)
        }).catch((err) => {
          this.onGetAdsError()
        })
      },

      onGetAdsSuccess(data) {
        const attachedAd = data.find(ad => ad.id === this.campaignAdId),
              // Check if the merchant's current time is still in range when they click on "send campaign" button
              isStillInRange = this.sendNow && (attachedAd?.time_range_start && attachedAd?.time_range_end) ? isInDateTimeRangeUtil({
                timeZone: this.currentMerchant.merchant_time_zone,
                startHour: removeTimeZoneAndGetDateUtil(attachedAd.time_range_start)?.getHours(),
                endHour: removeTimeZoneAndGetDateUtil(attachedAd.time_range_end)?.getHours(),
                addBuffer: true
              }) : true

        if (this.submit && attachedAd && attachedAd.attachments.length > 0) {
          this.showAlertModal = attachedAd.attachments[0].uuid !== this.attachedAdImageUUID || !isStillInRange
        }

        this.loading = false

        if (this.showAlertModal === false) {
          this.shouldShowWarning()
        }
      },

      onGetAdsError(error) {
        this.adsError = `issue updating the ads list. ${error}`
        this.loading = false
      },

      removeAd() {
        this.$refs.adslist.removeAd(true)
        this.showAlertModal = false
      },

      toggleSelectedView(clickedView) {
        this.selectedView = clickedView
      },

      toggleSend(sendType) {
        this[`${sendType}Send`] = !this[`${sendType}Send`]

        const dataToUpdate = { sms_send: this.smsSend, email_send: this.emailSend }

        if (sendType === 'sms' && !this.smsSend && !!this.campaign.ad) {
          Object.assign(dataToUpdate, {
            ad_id: null,
            sms_sent: null,
            image_type: 'mms'
          })

          if (!!this.adFilters) this.adFilters = null

          const selectedMessageTemplate = this.$store.getters.selectedNotificationTemplateFor('message')
          if (selectedMessageTemplate?.type === 'brand') {
            dataToUpdate['template_id'] = null
          }
        }

        this.updateCampaign(dataToUpdate)
        this.validateMessageType()
      },

      updateAlerts(itemKey, alert) {
        this.UPDATE_STATE_OBJECT({stateKey: 'alerts', itemKey, itemObject: alert})
      },

      async updateCampaign(dataToUpdate, shouldSend, isCancel, adSuggestedText = null, updateSuggestedText = false) {
        if (updateSuggestedText){
          await this.updateSmsSuggestedText(adSuggestedText)
        }
        const url = `/api/v3/campaigns/${this.campaignId}`,
          methodType = 'patch',
          params = { campaign: dataToUpdate },
          errorVerb = shouldSend ? 'saving' : 'updating',
          errorText = `we encountered an issue ${errorVerb} the campaign`,
          onExtraParam = { errorType: 'campaignUpdate', errorText, shouldSend, isCancel }
        this.axiosMethod({methodType, url, params, onSuccess: this.afterUpdateCampaign, onError: this.setApiError, onExtraParam})
      },

      updateData(field, value) {
        this[field] = value
      },

      updateSmsSuggestedText(text){
        this.UPDATE_AD_SUGGESTED_TEXT(text)
        const url = `/api/v3/campaigns/${this.campaignId}/update_sms_content`
        const params = {text}
        return this.axiosMethodPromise({methodType: 'patch', url, params})
      },

      updateMmsAlert() {
        let message = `you used ${this.mmsType} in this message - that's awesome! heads up though - once ${this.mediaCreditMessage}`,
          mmsAlert = !!this.mediaCredits && !this.mmsAsLink ? { extraClasses: 'mms-alert', message} : {}
        this.updateAlerts('mediaUsed', mmsAlert)
      },

      validateMessageType() {
        if(!this.smsSend && !this.emailSend) {
          this.isAllValid('sendType', { sendValid: 'no send type selected' })
        } else {
          this.isAllValid('sendType', { })
        }
      },

      setAgreementTerms() {
        const payload = { checked_dont_show_text_marketing_warning: !!this.agreementCheck }
        return textMarketingAPI.PATCHTextMarketing(payload
        ).catch(function(error) {
          console.error(error)
        }).finally(() => {
          this.showAgreementModal = false
          this.initCampaign()
        })
      },

      getAgreementTerms() {
        textMarketingAPI.GETTextMarketing().then((data) => {
          this.showAgreementModal = data?.should_show_modal
        }).catch(function(error) {
          console.error(error)
        }).finally(() => {
          this.initCampaign()
        })
      },

      async refreshTotalCount() {
        this.loadingTotalCount = true;
        this.totalRecipientCount = await campaignAPI.totalRecipientCount(this.campaign.id, this.selectedView === 'email');
        this.prevRecipientCount = this.totalRecipientCount;
        this.loadingTotalCount = false;
      },

      ...mapActions({
        LOAD_CAMPAIGN_CONFIGURATION: 'LOAD_CAMPAIGN_CONFIGURATION',
        UPDATE_AD: 'message/UPDATE_AD',
        UPDATE_AD_IMAGE_URL: 'message/UPDATE_AD_IMAGE_URL',
        UPDATE_AD_SUGGESTED_TEXT: 'message/UPDATE_AD_SUGGESTED_TEXT',
        UPDATE_BOOLEAN_STATUS: 'message/UPDATE_BOOLEAN_STATUS',
        UPDATE_COMMUNICATION_ITEMS: 'message/UPDATE_COMMUNICATION_ITEMS',
        UPDATE_MESSAGE_ID_TYPE: 'message/UPDATE_MESSAGE_ID_TYPE',
        UPDATE_MESSAGE_STATE: 'message/UPDATE_MESSAGE_STATE',
        UPDATE_SMS_CONTENT: 'message/UPDATE_SMS_CONTENT',
        UPDATE_STATE_OBJECT: 'UPDATE_STATE_OBJECT'
      })
    },

    beforeCreate() {
      const moduleNames = ['backup', 'message']
      moduleNames.forEach(name => !this.$store.hasModule(name) && this.$store.registerModule(name, MessageModule))
    },

    created() {
      this.getAgreementTerms();

      window.onbeforeunload = () => {
        if (this.hasAd) {
          const dataToUpdate = { ad_id: null, sms_sent: null }
          const selectedMessageTemplate = this.$store.getters.selectedNotificationTemplateFor('message')
          if (selectedMessageTemplate?.type === "brand") {
            dataToUpdate["template_id"] = null
          }

          if (!!this.adFilters) this.adFilters = null

          this.updateCampaign(dataToUpdate)
          return 'are you sure you want to leave?'
        }
      }
    },

    beforeDestroy() {
      const moduleNames = ['backup', 'message']
      moduleNames.forEach(name => !!this.$store.hasModule(name) && this.$store.unregisterModule(name))
      this.$store.commit('RESET_ALERTS')
    },

    computed: {
      backupAdOverCreditLimit: function() {
        return this.hasBackup && this.backupHasAd && (this.backupCredits > this.maxAdCampaignCredits)
      },

      backupIsSms: function() {
        return (this.hasAd && !this.adAsLink) || this.mediaCredits > 0
      },

      backupIsValid: function() {
        const validBackupMms = (this.backupHasAd && !this.backupAdAsLink) || this.backupMediaCredits > 0,
          backupBlacklistValid = this.allowBlockBlacklist ? !this.backupHasBlacklistedWords : true
        return (this.backupIsSms ? !!this.backupSmsContent?.length : validBackupMms) && backupBlacklistValid
      },

      hasBackup: function() {
        return this.showBackup && this.backupId && !this.shouldCancelBackup
      },

      hasNoErrors: function () {
        let errorKeys = this.errors ? Object.keys(this.errors) : []
        return errorKeys.length < 1
      },

      hideCarriersGroup: function () {
        return this.merchantCountryIsCanada || this.showBackup
      },

      mediaCreditMessage: function() {
        return `${this.mmsType} is included in a message, a minimum of 2 credits are charged`
      },

      parentAdOverCreditLimit: function() {
        return this.hasAd && this.credits > this.maxAdCampaignCredits
      },

      validCampaign: function () {
        const hasUserInteractions = this.noUserInteractions ? Object.keys(this.noUserInteractions).length < 1 : false,
          validParentCampaign = this.hasNoErrors && hasUserInteractions;

        if(this.classicCampaignsEnabled === false) {
          if(this.smsSend === true && !this.hasSelectedNotification) {
            return false
          }
        }

        if(this.campaign.email_send && !this.campaign.has_email_template) {
          return false
        }

        return this.hasBackup ? validParentCampaign && this.backupIsValid : validParentCampaign
      },

      ...mapGetters({
        adAsLink: 'message/adAsLink',
        adId: 'message/adId',
        audios: 'message/audios',
        backupAdAsLink: 'backup/adAsLink',
        backupHasAd: 'backup/hasAd',
        backupMediaCredits: 'backup/mediaCredits',
        hasAd: 'message/hasAd',
        mediaCredits: 'message/mediaCredits',
        merchantCountryIsCanada: 'merchantCountryIsCanada',
        mmsAsLink: 'message/mmsAsLink',
        mmsType: 'message/mmsType',
        showFiltersAlert: 'showFiltersAlert',
        totalCredits: 'message/totalCredits'
      }),

      ...mapGetters(['classicCampaignsEnabled', 'useCampaignEditor2', 'campaignHasErrors']),

      showBrands() {
        return this.$store.getters.showBrands && !this.$store.getters.classicCampaignsEnabled
      },

      hasSelectedNotification() {
        return !!this.$store.getters.selectedNotificationTemplateFor('message')
      },

      ...mapState({
        alerts: state => state.alerts,
        allowBlockBlacklist: state => state.allowBlockBlacklist,
        backupCredits: state => state.backup.credits,
        backupHasEmoji: state => state.backup.hasEmoji,
        backupHasBlacklistedWords: state => state.backup.hasBlacklistedWords,
        backupId: state => state.backup.messageId,
        backupSmsContent: state => state.backup.updatedSmsContent,
        credits: state => state.message.credits,
        emojiAlertMessage: state => state.emojiAlertMessage,
        classicEmojiAlertMessage: state => state.classicEmojiAlertMessage,
        errors: state => state.errors,
        hasBlacklistedWords: state => state.message.hasBlacklistedWords,
        hasEmoji: state => state.message.hasEmoji,
        noUserInteractions: state => state.noUserInteractions,
        messageType: state => state.message.messageType
      }),

      ...mapState([ "currentMerchant" ])
    },

    watch: {
      hasBlacklistedWords: function () {
        this.updateCampaign({ has_blacklisted_words: this.hasBlacklistedWords })
      },

      hasEmoji: function () {
        let alertMessage = this.classicCampaignsEnabled ? this.classicEmojiAlertMessage : this.emojiAlertMessage;

        const emojiAlert = this.hasEmoji ? { extraClasses: "emoji-alert", message: alertMessage } : {}
        this.updateAlerts('emojiUsed', emojiAlert)
      },

      hasNoErrors: function () {
        const message = 'please complete required fields in red',
          alert = this.hasNoErrors ? {} : {extraClasses: 'error-alert', message}
        this.updateAlerts('campaignHasErrors', alert)
      },

      mmsAsLink: function () {
        this.updateMmsAlert()
      },

      mediaCredits: function () {
        this.updateMmsAlert()
      },
    }
  }
</script>

<style>
.campaign-edit-section .send-cancel-section .disabled {
  pointer-events: none;
}
</style>
